import React from "react";

function Delivered() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 -1 16.933 16.933"
    >
      <path
        fill="#ff9751"
        d="M1.322.53a.797.797 0 00-.793.792v7.674c0 .436.358.793.793.793h8.733a.796.796 0 00.792-.793V1.322a.797.797 0 00-.792-.793z"
        data-original="#ff9751"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#ff7f29"
        d="M10.281.566a.776.776 0 01.037.227v7.674a.796.796 0 01-.792.793H.793a.776.776 0 01-.227-.037c.1.325.4.566.756.566h8.733a.796.796 0 00.792-.793V1.322a.795.795 0 00-.566-.756z"
        data-original="#ff7f29"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#e4eff8"
        d="M4.232.53v2.91c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 00.397-.228V.53zm6.615 5.027c-1.312 0-2.38 1.069-2.38 2.38s1.068 2.381 2.38 2.381c1.312 0 2.382-1.069 2.382-2.38s-1.07-2.381-2.382-2.381zM1.852 8.202c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zm1.058 0c0 .354.53.354.53 0V6.88c0-.353-.53-.353-.53 0zm1.059 0c-.001.354.53.354.529 0V6.88c0-.353-.53-.353-.53 0z"
        data-original="#e4eff8"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#c4dcf0"
        d="M10.847 5.557a2.384 2.384 0 00-2.38 2.38c0 .791.39 1.492.985 1.925a2.364 2.364 0 01-.456-1.395 2.384 2.384 0 012.38-2.381c.521 0 1.003.17 1.395.456a2.378 2.378 0 00-1.924-.985z"
        data-original="#c4dcf0"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#549ad4"
        d="M13.225 5.818a.265.265 0 00-.182.08l-2.195 2.194-.871-.871c-.25-.25-.625.125-.375.375l1.058 1.058a.265.265 0 00.375 0l2.381-2.38a.265.265 0 00-.191-.456z"
        data-original="#549ad4"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#c4dcf0"
        d="M6.616.53v2.91a.26.26 0 01-.036.131l.168.097a.265.265 0 00.397-.228V.53z"
        data-original="#c4dcf0"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
      <path
        fill="#c4dcf0"
        d="M5.69 2.53l-1.06.609a.265.265 0 01-.398-.229v.53c0 .204.222.331.399.228l1.059-.61 1.058.61a.265.265 0 00.397-.228v-.53c0 .204-.221.33-.397.229z"
        data-original="#c4dcf0"
        transform="matrix(1.25 0 0 1.3 0 0)"
      ></path>
    </svg>
  );
}

export default Delivered;
